import React from "react";
import { object, array, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Organism1 from "./Organism1";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import NewsWithImage from "../../molecules/NewsWithImage";

import { getSlug, getCollectionName } from "../../utils/utils";

import "./fourStories.m.css";

const FourStories = ({ collection, sections, domainSlug }) => {
  if (
    !collection ||
    !collection.items ||
    !collection.items.length ||
    !collection.items.filter((item) => item.type === "story").length
  ) {
    return null;
  }

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");

  const collectionName = getCollectionName(collection, navigateToTitle);
  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);
  const stories = collection.items
    .filter((item) => item.type === "story")
    .slice(0, 4)
    .map((item) => item.story);

  return (
    <div styleName="wrapper" className="four-stories">
      {showCollectionName && (
        <CollectionTitleWithArrow collectionName={collectionName} collectionSlug={collectionSlug} />
      )}

      <div styleName="stories">
        <div styleName="first-story">
          {stories.splice(0, 1).map((story, index) => (
            <NewsWithImage
              story={story}
              key={index}
              cssStyleName="semiBigSize"
              aspectRatio={[16, 9]}
              imageType="image16x9"
              showExcerpt={true}
            />
          ))}
        </div>

        <Organism1 stories={stories.splice(0, 3)} />
      </div>
    </div>
  );
};

FourStories.propTypes = {
  collection: object,
  sections: array,
  domainSlug: string,
};

FourStories.storyLimit = 4;

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

export default connect(mapStateToProps, null)(FourStories);
